// import React from 'react';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "./ui/card";
import { CheckCircle, Mail } from "lucide-react";
import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";

interface RegistrationSuccessProps {
  email: string;
  onBackToLogin?: () => void;
}

export function RegistrationSuccess({ email, onBackToLogin }: RegistrationSuccessProps) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 relative">
            <Mail className="h-16 w-16 text-blue-600" />
            <CheckCircle className="h-8 w-8 text-green-600 absolute bottom-0 right-0 -mr-2 -mb-2 bg-white rounded-full" />
          </div>
          <CardTitle className="text-2xl">Check Your Email!</CardTitle>
          <CardDescription className="text-base mt-2">
            We've sent a verification email to:
          </CardDescription>
        </CardHeader>

        <CardContent className="space-y-6">
          <div className="bg-gray-50 rounded-lg p-4 text-center">
            <p className="font-medium text-gray-900">{email}</p>
          </div>

          <div className="space-y-4 text-sm text-gray-600">
            <p>
              Please click the verification link in the email to activate your
              account.
            </p>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <p className="font-medium text-blue-900 mb-2">
                Didn't receive the email?
              </p>
              <ul className="space-y-1 text-blue-800">
                <li>• Check your spam or junk folder</li>
                <li>• Make sure you entered the correct email</li>
                <li>• Wait a few minutes and check again</li>
              </ul>
            </div>
          </div>

          <div className="space-y-3">
            <Button
              onClick={() => navigate("/verify-email")}
              variant="outline"
              className="w-full"
            >
              Resend Verification Email
            </Button>

            <Button
              onClick={() => {
                if (onBackToLogin) {
                  onBackToLogin();
                } else {
                  navigate("/login");
                }
              }}
              variant="default"
              className="w-full"
            >
              Back to Login
            </Button>
          </div>

          <div className="text-center text-xs text-gray-500">
            The verification link will expire in 24 hours
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default RegistrationSuccess;

